import { useSelector } from 'react-redux';
import { toast } from 'sonner';

const useSmartReplyValidator = () => {
  const agentTitle = useSelector(state => state?.agent?.smartReply?.title);
  const engineId = useSelector(state => state?.agent?.smartReply?.smartReplyData?.engineId);
  const protocolType = useSelector(
    state => state?.agent?.smartReply?.smartReplyData?.protocol?.type
  );
  const protocolConfig = useSelector(state => state?.agent?.smartReply?.smartReplyData?.protocol);

  const actionBucketIds = useSelector(
    state => state?.agent?.smartReply?.smartReplyData?.actionBucketIds
  );
  const currentType = useSelector(state => state?.agent?.smartReply?.smartReplyData?.type);
  const providerData = useSelector(state => state?.agent?.smartReply?.smartReplyData?.providerData);
  const integrationId = useSelector(
    state => state?.agent?.smartReply?.smartReplyData?.integrationId
  );

  const validateBasicFields = () => {
    const hasValidTitle = agentTitle && agentTitle.trim().length > 0;
    const hasValidEngineId = engineId && engineId._id && engineId._id.length > 0;

    if (!hasValidTitle) {
      toast.warning('Enter a name for this agent');
      return true;
    }

    if (!hasValidEngineId) {
      toast.warning('Pick an engine for this agent');
      return true;
    }

    return false;
  };

  const validateProtocolConfig = () => {
    if (protocolType === 'graphAPI') {
      const { clientId, clientSecret, authority, email } = protocolConfig;

      if (!clientId || !clientSecret || !authority || !email) {
        toast.warning('Fill in every Microsoft Graph API field');
        return true;
      }
    }

    if (protocolType === 'imap') {
      const { host, port, username, password, email } = protocolConfig;
      if (!host || !port || !username || !password || !email) {
        toast.warning('Fill in every IMAP field');
        return true;
      }
    }

    if (protocolType === 'freshdesk') {
      const { apiKey, domain, email } = protocolConfig;
      if (!apiKey || !domain || !email) {
        toast.warning('Fill in every Freshdesk field');
        return true;
      }
    }

    return false;
  };

  const isSmartReplyDesignNextButtonDisabled = () => {
    const hasActionBucketIds = Array.isArray(actionBucketIds) && actionBucketIds.length > 0; // for backward compatibility

    if (!hasActionBucketIds) {
      toast.warning('Add at least one collection');
      return true;
    }

    if (currentType && currentType === 'email') {
      const hasProtocolErrors = validateProtocolConfig();
      if (hasProtocolErrors) {
        return true;
      }
    } else if (currentType && currentType === 'whatsapp') {
      const isMeta = providerData?.type === 'meta' || Boolean(integrationId);

      if (isMeta) {
        if (!integrationId) {
          toast.warning('Select a WhatsApp number');
          return true;
        }
      } else if (
        !providerData ||
        !providerData?.type ||
        !providerData?.accountSID ||
        !providerData?.authToken ||
        !providerData?.phoneNumber
      ) {
        toast.warning('Fill in every WhatsApp field');
        return true;
      }
    }

    return false;
  };

  const isSmartReplyDefineNextButtonDisabled = () => {
    const hasBasicFieldErrors = validateBasicFields();
    if (hasBasicFieldErrors) {
      return true;
    }

    return false;
  };

  return { isSmartReplyDefineNextButtonDisabled, isSmartReplyDesignNextButtonDisabled };
};

export default useSmartReplyValidator;
